import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useEffect } from 'react';

/**
 * Theme mode for the app shell. Dark is the default per the design system;
 * light is opt-in. Persisted per-browser in localStorage. The atom drives a
 * `data-theme` attribute on the `<html>` element; CSS variables in
 * `@studio/ui/tokens.css` flip on `[data-theme='light']`.
 */
export type ThemeMode = 'dark' | 'light';

export const themeAtom = atomWithStorage<ThemeMode>('aps:theme', 'dark');

/**
 * Subscribes the document root to the theme atom. Mount once at the app
 * shell. Removes the attribute when the theme is the default (dark) so the
 * attribute is only present when overriding.
 */
export function useApplyTheme(): void {
  const [theme] = useAtom(themeAtom);
  useEffect(() => {
    if (theme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [theme]);
}
